import { render, staticRenderFns } from "./triggerTab.vue?vue&type=template&id=16b7a005&lang=pug"
import script from "./triggerTab.vue?vue&type=script&lang=js"
export * from "./triggerTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports